<template>
	<div class="imagebackup">
		<Nav></Nav>
		<div class="about-photo-wrap">
			<div class="about-photo">
				<div class="back-wrap">
					<div class="back" @click="goClick">
						<div class="back-icon"></div>
						小宝视频
					</div>
					<div class="device-wrap" @click="showClick" v-if="false">
						<div class="device-icon"></div>
						<div class="device-text">nas</div>
						<div
							:class="{
								'device-icon2': true,
								'device-icon3': isShowDeviceList,
							}"
						></div>
					</div>
					<div class="device-list" v-if="isShowDeviceList">
						<div class="device-item-list">
							<div class="item">
								<div class="item-text">设备nas</div>
								<div class="item-text2">192.......</div>
								<div class="item-icon"></div>
							</div>
							<div class="item">
								<div class="item-text">设备nas</div>
								<div class="item-text2">192.......</div>
								<div class="item-icon"></div>
							</div>
							<div class="item">
								<div class="item-text">设备nas</div>
								<div class="item-text2">192.......</div>
								<div class="item-icon"></div>
							</div>
							<div class="item">
								<div class="item-text">设备nas</div>
								<div class="item-text2">192.......</div>
								<div class="item-icon"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="line"></div>
				<div class="backup-part">
					<div
						:class="{
							'backup-icon': true,
							'backup-icon-pc': dtype && dtype == 3,
							'backup-icon-ly': dtype && dtype == 2,
						}"
					></div>
					<div class="device-name">
						<div class="device-text">{{ dev_name }}</div>
						<div class="device-text2">{{ dev_ip }}</div>
					</div>
					<div class="backup-addr">
						<div class="addr-text">视频备份路径</div>
						<div
							class="addr-text2"
							:title="backupPath"
							:alt="backupPath"
						>
							{{ backupPath ? backupPath : "-" }}
						</div>
					</div>
				</div>
				<div class="backup-part2">
					<div class="about-icon"></div>
					<div class="about-text-wrap">
						<div class="about-text">一键导出手机视频</div>
						<div class="about-text about-text2">
							可备份至电脑/NAS
						</div>
					</div>
					<div class="about-btn" @click="howClick">如何备份</div>
				</div>
				<div class="record-title">备份记录</div>
				<div class="record-header">
					<div class="header-text header-text1">备份时间</div>
					<div class="header-text header-text2">手机</div>
					<div class="header-text header-text3">备份设备</div>
					<div class="header-text header-text4">备份设备</div>
					<div class="header-text header-text5">备份路径</div>
				</div>
				<div class="record-list">
					<div class="record-empty" v-if="list.length <= 0">
						暂无备份记录
					</div>
					<div
						class="record-item"
						:key="item.id"
						v-for="item in list"
					>
						<div class="record-text record-text1">
							{{ item.time }}
						</div>
						<div class="record-text record-text2">
							{{ item.client_model }}
						</div>
						<div class="record-text record-text3">
							{{ item.dev_name }}
						</div>
						<div class="record-text record-text4">
							{{ item.album_count }}相册,{{
								item.photo_count
							}}视频
						</div>
						<div class="record-text record-text5">
							{{ item.path }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Nav from "@/components/Common/Nav.vue";
import { mapActions } from "vuex";
export default {
	components: {
		Nav,
	},
	data: function () {
		return {
			pidInfo: { cid: null, did: null },
			backupPath: "",
			cur_pid: this.$route.params.cur_pid
				? this.$route.params.cur_pid
				: "",
			dev_name: this.$route.params.dev_name
				? this.$route.params.dev_name
				: "",
			dev_ip: this.$route.params.dev_ip ? this.$route.params.dev_ip : "",
			dtype: this.$route.params.dtype ? this.$route.params.dtype : "",
			isShowDeviceList: false,
			list: [],
		};
	},
	methods: {
		...mapActions(["getUserImagebackupLog", "getUserImagebackupPath"]),
		showClick: function () {
			let _that = this;
			_that.isShowDeviceList = !_that.isShowDeviceList;
		},
		goClick: function () {
			this.$router.back(-1);
		},
		howClick: function () {
			let _that = this;
			_that.$router.push("/home/videobackuphelp");
		},
		renderList: function () {
			let _that = this;
			_that.list = [];
			_that.getUserImagebackupLog([
				_that.cur_pid,
				"video",
				1,
				10000,
				function (err, data) {
					// console.log(data);
					_that.list = data.data.list;
				},
			]);
			_that.getUserImagebackupPath([
				_that.cur_pid,
				function (err, data) {
					// console.log(data);
					if (!err && data) {
						_that.backupPath = data.data.path;
					} else {
						_that.backupPath = "";
					}

					if (_that.backupPath == "") {
						if (
							_that.pidInfo.cid == 101 ||
							_that.pidInfo.cid == 123
						) {
							_that.backupPath = "<共享路径>/OWData/photos";
						} else if (_that.pidInfo.cid == 126) {
							_that.backupPath = "<共享路径>/OWSpeedup/photos";
						} else if (_that.pidInfo.cid == 108) {
							_that.backupPath =
								"<共享路径>/OWSpeedup/OWData/photos";
						}
					}
				},
			]);
		},
	},
	activated: function () {
		let _that = this;
		// console.log("_that.cur_pid", _that.cur_pid);
		// if (!_that.cur_pid) {
		// 	_that.goClick();
		// 	return;
		// }
		_that.backupPath = "";
		_that.cur_pid = _that.$route.params.cur_pid
			? _that.$route.params.cur_pid
			: "";
		_that.pidInfo = _that.$common.getInfoByPid(_that.cur_pid);
		_that.dev_name = _that.$route.params.dev_name
			? _that.$route.params.dev_name
			: "";
		_that.dev_ip = _that.$route.params.dev_ip
			? _that.$route.params.dev_ip
			: "";
		_that.dtype = _that.$route.params.dtype
			? _that.$route.params.dtype
			: "";
		_that.isShowDeviceList = false;
		_that.list = [];
		_that.renderList();
	},
};
</script>
<style lang="less" scoped>
.about-photo-wrap {
	width: 100%;
}
.about-photo {
	margin: 0 auto;
	padding-top: 8px;
	width: 932px;
	height: 524px;
	box-sizing: border-box;
	border-radius: 4px;
	background-image: url("../assets/tool/imagebackup-bg.png");
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-color: #ffffff;
	border: 1px solid #dddddd;
	border-radius: 4px;
	.back-wrap {
		position: relative;
		.back {
			padding-left: 26px;
			width: 150px;
			line-height: 48px;
			font-size: 14px;
			color: #666666;
			cursor: pointer;

			.back-icon {
				display: inline-block;
				margin-top: 15px;
				margin-right: 8px;
				vertical-align: top;
				width: 16px;
				height: 16px;
				background-image: url("../assets/device/infoBack.svg");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
		}
		.device-wrap {
			position: absolute;
			padding-right: 24px;
			padding-left: 12px;
			right: 0;
			top: 0px;
			height: 48px;
			cursor: pointer;
			.device-icon {
				display: inline-block;
				margin-top: 13px;
				vertical-align: top;
				width: 20px;
				height: 20px;
				border-radius: 50%;
				background-color: #757575;
			}
			.device-text {
				display: inline-block;
				margin-left: 8px;
				vertical-align: top;
				font-weight: 600;
				font-size: 14px;
				line-height: 48px;
				color: #666666;
			}
			.device-icon2 {
				display: inline-block;
				margin-left: 24px;
				margin-top: 17px;
				vertical-align: top;
				width: 16px;
				height: 16px;
				background-image: url("../assets/tool/tool11.svg");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
			.device-icon3 {
				background-image: url("../assets/tool/tool14.svg");
			}
		}
		.device-list {
			position: absolute;
			right: 24px;
			top: 56px;
			width: 292px;
			height: 348px;
			background-color: #ffffff;
			box-shadow: 0px 8px 16px rgba(44, 46, 54, 0.2);
			border-radius: 8px;
			.device-item-list {
				padding-top: 1px;
				width: 292px;
				height: 348px;
				overflow: auto;
				padding-bottom: 10px;
				box-sizing: border-box;
				.item {
					position: relative;
					padding-top: 1px;
					padding-left: 30px;
					margin: 0 auto;
					margin-top: 19px;
					width: 260px;
					height: 68px;
					box-shadow: 0px 2px 6px rgba(141, 152, 171, 0.1);
					border-radius: 4px;
					border: 1px solid rgba(191, 199, 218, 0.5);
					box-sizing: border-box;
					background-color: #f9fafb;
					cursor: pointer;
					.item-text {
						position: relative;
						margin-top: 12px;
						font-weight: 600;
						font-size: 16px;
						line-height: 22px;
						color: #1f1f1f;
					}
					.item-text::before {
						position: absolute;
						left: -16px;
						top: 7px;
						content: "";
						width: 8px;
						height: 8px;
						border-radius: 50%;
						background-color: #143977;
					}
					.item-text2 {
						margin-top: 4px;
						font-size: 12px;
						line-height: 17px;
						color: #999999;
					}
					.item-icon {
						position: absolute;
						right: 16px;
						top: 23px;
						width: 12px;
						height: 24px;
						background-image: url("../assets/tool/tool13.svg");
						background-repeat: no-repeat;
						background-size: 100% 100%;
					}
				}
				.item:hover {
					border: 1px solid rgba(0, 71, 255, 0.5);
					background-color: #eef7ff;
				}
			}
		}
		.device-list::before {
			position: absolute;
			top: -10px;
			right: 22px;
			content: "";
			width: 20px;
			height: 12px;
			background-image: url("../assets/tool/tool12.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
	}
	.line {
		margin: 0 auto;
		width: 896px;
		height: 1px;
		background-color: rgba(233, 233, 234, 0.5);
	}
	.backup-part {
		display: inline-block;
		padding-top: 1px;
		margin-top: 14px;
		margin-left: 18px;
		vertical-align: top;
		width: 273px;
		height: 156px;
		background-image: url("../assets/tool/tool8.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
		.backup-icon {
			display: inline-block;
			margin-top: 30px;
			margin-left: 30px;
			vertical-align: top;
			width: 40px;
			height: 40px;
			border-radius: 50%;
			background-image: url(../assets/device/deviceOn.png);
			background-repeat: no-repeat;
			background-size: 100% 100%;
			box-shadow: 0px 2px 4px rgba(114, 129, 182, 0.2);
		}
		.backup-icon-pc {
			background-image: url(../assets/device/devicePc.png);
		}
		.backup-icon-ly {
			background-image: url(../assets/device/deviceLy.png);
		}
		.device-name {
			display: inline-block;
			margin-top: 28px;
			margin-left: 8px;
			vertical-align: top;
			.device-text {
				font-weight: 600;
				font-size: 18px;
				line-height: 24px;
				color: #1a1a1a;
				width: 175px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
			.device-text2 {
				margin-top: 3px;
				font-size: 12px;
				line-height: 17px;
				color: #999999;
			}
		}
		.backup-addr {
			padding-top: 1px;
			margin: 0 auto;
			margin-top: 14px;
			width: 246px;
			height: 53px;
			background: rgba(254, 254, 254, 0.5);
			border-radius: 4px;
			box-sizing: border-box;
			.addr-text {
				margin-top: 8px;
				margin-left: 18px;
				font-size: 12px;
				line-height: 18px;
				color: #1a1a1a;
			}
			.addr-text2 {
				margin-left: 18px;
				margin-top: 4px;
				font-size: 12px;
				line-height: 18px;
				color: #999999;
				width: 220px;
				white-space: nowrap; //   强制在同一行内显示所有文本
				overflow: hidden; //多余的内容隐藏掉
				text-overflow: ellipsis; // 溢出的部分显示省略号
			}
		}
	}
	.backup-part2 {
		display: inline-block;
		padding-top: 1px;
		margin-top: 14px;
		margin-left: 14px;
		vertical-align: top;
		width: 610px;
		height: 156px;
		background-image: url("../assets/tool/spbf-bg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
		.about-icon {
			margin-top: 34px;
			margin-left: 55px;
			width: 88px;
			height: 21px;
			background-image: url("../assets/tool/spbf-title.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
		.about-text-wrap {
			margin-left: 62px;
			margin-top: 8px;
			.about-text {
				display: inline-block;
				margin-left: 6px;
				position: relative;
				vertical-align: top;
				font-size: 12px;
				line-height: 18px;
				color: #123874;
			}
			.about-text::before {
				position: absolute;
				content: "";
				left: -12px;
				top: 6px;
				width: 4px;
				height: 4px;
				border-radius: 50%;
				background-color: #123874;
			}
			.about-text2 {
				margin-left: 30px;
			}
		}
		.about-btn {
			margin-left: 55px;
			margin-top: 14px;
			width: 89px;
			height: 28px;
			background: #123874;
			border-radius: 42px;
			font-weight: 600;
			font-size: 12px;
			line-height: 28px;
			text-align: center;
			color: #ffffff;
			cursor: pointer;
		}
		.about-btn:hover {
			opacity: 0.9;
		}
	}
	.record-title {
		margin-top: 12px;
		margin-left: 40px;
		font-weight: 600;
		font-size: 12px;
		line-height: 17px;
		color: #1a1a1a;
	}
	.record-header {
		padding-bottom: 5px;
		margin-top: 15px;
		margin-left: 40px;
		height: 22px;
		width: 854px;
		font-weight: 500;
		font-size: 12px;
		line-height: 22px;
		color: #666666;
		.header-text {
			display: inline-block;
			vertical-align: top;
		}
		.header-text1 {
			width: 19%;
		}
		.header-text2 {
			width: 16%;
		}
		.header-text3 {
			width: 18%;
		}
		.header-text4 {
			width: 22%;
		}
		.header-text5 {
			width: 24%;
		}
	}
	.record-list {
		margin-left: 40px;
		width: 854px;
		height: 172px;
		overflow: auto;
		.record-empty {
			font-size: 12px;
			text-align: center;
			color: #666666;
			padding-top: 20px;
			border-top: 1px solid #eeeeee;
		}
		.record-item {
			height: 40px;
			line-height: 40px;
			font-size: 12px;
			color: #666666;
			border-top: 1px solid rgba(230, 230, 230, 0.5);
			.record-text {
				display: inline-block;
				vertical-align: top;
			}
			.record-text1 {
				width: 19%;
			}
			.record-text2 {
				width: 16%;
			}
			.record-text3 {
				width: 18%;
			}
			.record-text4 {
				width: 22%;
			}
			.record-text5 {
				width: 25%;
				white-space: nowrap; //   强制在同一行内显示所有文本
				overflow: hidden; //多余的内容隐藏掉
				text-overflow: ellipsis; // 溢出的部分显示省略号
			}
		}
	}
}
</style>